export class PaginationInfo {
    actualPage: number;
    itemsPage: number;
    totalPages: number;
    searchValue: string;
    lastMonth: number;
}
